module.exports = __webpack_public_path__ + "static/img/foto-modal.224141b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/foto-modal.jpg
// module id = YICm
// module chunks = 8